import React from 'react';
import {Tag} from 'antd';
import dayjs from 'dayjs';
import {useTranslation} from '../../../../hooks/useTranslation';
import {useDateFormat} from '../../../../hooks/useDateFormat';
import {getReadableText, getSeverityColor, hexToRgba, isLight} from '../../../../utils/ColorHelper';
import MetaTable from '../../../../components/common/MetaTable';

export interface IssueSummaryCardProps {
  code?: string;
  statusLabel?: string;
  statusColor?: string;
  reportedBy?: string;
  reportedOn?: string; // ISO timestamp — formatted with the active locale
}

const IssueSummaryCard: React.FC<IssueSummaryCardProps> = ({
                                                             code,
                                                             statusLabel,
                                                             statusColor,
                                                             reportedBy,
                                                             reportedOn,
                                                           }) => {
  const {t} = useTranslation();
  const {dateTimeFormat} = useDateFormat();

  const accent = statusColor ? getSeverityColor(statusColor) : undefined;
  const statusTag = statusLabel ? (
    <Tag
      variant="filled"
      style={{
        margin: 0,
        fontWeight: 600,
        fontSize: 14,
        padding: '4px 16px',
        borderColor: accent ? hexToRgba(accent, isLight(accent) ? 0.7 : 0.45) : undefined,
        color: accent ? getReadableText(accent) : undefined,
      }}
    >
      {statusLabel}
    </Tag>
  ) : '—';

  return (
    <div className="issue-summary-card">
      <MetaTable
        rows={[
          {
            key: 'status',
            label: t('issues.detail.form.summary.status'),
            value: statusTag,
          },
          {
            key: 'reportedBy',
            label: t('issues.detail.form.summary.reportedBy'),
            value: reportedBy || '—',
          },
          {
            key: 'reportedOn',
            label: t('issues.detail.form.summary.reportedOn'),
            value: reportedOn ? dayjs(reportedOn).format(dateTimeFormat) : '—',
          },
        ]}
      />
    </div>
  );
};

export default IssueSummaryCard;
